// 农事日历
<template>
  <el-card class="card-main">
    <el-form ref="searchInfo" :model="searchInfo" class="global-form" :inline="true">
      <el-form-item>
        <el-select v-model="searchInfo.projectId" placeholder="请选择项目" filterable clearable>
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchInfo.day" placeholder="请选择所属计划" filterable clearable>
          <el-option v-for="item in time" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="mb20">
      <el-button type="primary" icon="el-icon-plus" @click="onAdd" v-show="$ButtonShow('YPR_ADD_01')">新增计划</el-button>
    </div>
    <template v-if="planlist.length > 0">
      <div class="list-box" v-loading="loading">
        <div class="list-item" v-for="(item, index) in planlist" :key="index" @click="onClickItem(item.planId)">
          <div class="header">
            <p class="name">{{ item.projectName || '11' }}</p>
            <p class="time">{{ item.planStart }}至{{ item.planEnd }}</p>
            <div class="echart" :id="'echart' + index"></div>
          </div>
          <div class="list-content">
            <div v-for="(item, index) in item.taskList" :key="index">
              <img v-if="item.taskState === '1'" src="@/assets/img/icon_finished.png">
              <img v-if="item.taskState === '0'" src="@/assets/img/icon_unfinished.png">
              <span>{{ item.taskNotes }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <NoData v-else></NoData>
    <global-pagination :total="total" :current-page.sync="page" :pageSize="size"
      :pageSizes="[12, 24, 36, 48, 60, 120, 240]" @current-change="loadData"
      @size-change="loadData"></global-pagination>

  </el-card>
</template>

<script>
import * as Echarts from 'echarts'
import NoData from '@/components/NoData.vue'
export default {
  components: { NoData },
  data () {
    return {
      loading: false,
      // 列表
      planlist: [],
      // 编辑
      planId: '',
      size: 12,
      page: 1,
      total: 0,
      time: [],
      chart: {
      },
      searchInfo: {
        projectId: '',
        day: ''
      }
    }
  },
  computed: {
    projectList () {
      return this.$store.state.projectList
    }

  },
  watch: {
    'searchInfo.projectId' () {
      this.$axios.get(this.$apis.operationmanage.selectYhDailyPlanByList, {
        projectId: this.searchInfo.projectId
      }).then(res => {
        this.time = res.list.map((item) => item.planStart + '至' + item.planEnd)
      })
    }
  },

  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.operationmanage.selectYhDailyPlanByPage, {
        ...this.searchInfo,
        page: this.page,
        size: this.size
      }).then(res => {
        this.planlist = res.list || []
        this.total = res.total || 0
        this.planlist.forEach((plan, index) => {
          const count = plan.taskList.filter((t) => t.taskState === '1').length
          this.renderEchart(count, 'echart' + index, plan.taskList.length)
        })
      }).finally(() => {
        this.loading = false
      })
    },

    renderEchart (value, ref, total) {
      this.$nextTick(() => {
        this.chart['_' + ref] = Echarts.init(document.getElementById(ref))
        const option = {
          series: [{
            name: '11',
            type: 'pie',
            clockWise: false,
            radius: ['75%', '100%'],
            itemStyle: {
              normal: {
                color: '#9013FE',
                shadowBlur: 0,
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              }
            },
            hoverAnimation: false,
            data: [
              {
                value: value,
                label: {
                  normal: {
                    formatter: function (params) {
                      return (+params.value / total * 100).toFixed(1) + '%'
                    },
                    position: 'center',
                    show: true,
                    textStyle: {
                      fontSize: 14,
                      color: '#333333'
                    }
                  }
                }
              },
              {
                value: total === 0 ? 100 : total - value,
                name: 'invisible',
                itemStyle: {
                  normal: {
                    color: '#E0E0E0'
                  }
                }
              }
            ]
          }]
        }
        this.chart['_' + ref].clear()
        this.chart['_' + ref].setOption(option)
      })
    },

    onAdd () {
      this.$router.push({ name: 'PlanReportAdd' })
    },

    onSearch () {
      this.page = 1
      this.loadData()
    },

    onClickItem (item) {
      this.$router.push({ name: 'PlanReportDetail', params: { planId: item } })
    }
  }

}
</script>

<style lang='scss' scoped>
.list-box {
  display: flex;
  flex-wrap: wrap;
  // display: grid;
  // grid-template-columns: repeat(4, minmax(330px, 1fr));
  align-content: baseline;
  gap: 20px;
  height: calc(100% - 160px);
  background: #F6F7FB;
  border-radius: 4px 4px 2px 2px;
  padding: 20px;
  overflow: auto;

  .list-item {
    width: calc(25% - 20px);
    min-width: 330px;
    cursor: pointer;
    height: 254px;
    background: #FFFFFF;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
    border-radius: 4px;

    .header {
      position: relative;
      width: 100%;
      height: 84px;
      background: #F4F7FA;
      border: 1px solid #DFDDDD;
      padding: 15px 20px 20px;

      .name {
        width: calc(100% - 80px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 24px;
        font-size: 16px;
        color: #000;
        font-family: PingFangSC-Medium, PingFang SC;
        margin-bottom: 5px;
      }

      .time {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #9B9B9B;
        line-height: 24px;
        font-style: normal;
      }
    }

    .echart {
      position: absolute;
      top: 10px;
      right: 19px;
      width: 62px;
      height: 62px;
    }

    .list-content {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.45);
      line-height: 22px;
      font-style: normal;
      padding: 20px;
      height: calc(100% - 85px);
      overflow: auto;

      >div {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;

        img {
          width: 20px;
          height: 20px;
        }

        span {
          display: inline;
          line-height: 38px;
          padding-left: 10px;
          width: calc(100% - 20px);
          height: 38px;
          background: #F7F9F9;
          border-radius: 2px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-right: 10px;
        }
      }
    }
  }
}
</style>
